import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getSelectPage } from "../common/service";

export function limitSelectLoader() {
  return defer({
    coreData: resolveLoaderResult(getSelectPage()),
  });
}
